/**
 * Shift-click range selection over a rendered list.
 *
 * Sets every id between `fromIndex` and `toIndex` (inclusive, either
 * direction) of `orderedIds` to `select`, leaving the rest of `selectedIds`
 * untouched. `orderedIds` must be in the order the rows are rendered so the
 * range matches what the user sees.
 */
export function applyRangeSelection(
  selectedIds: string[],
  orderedIds: string[],
  fromIndex: number,
  toIndex: number,
  select = true
): string[] {
  const start = Math.min(fromIndex, toIndex);
  const end = Math.max(fromIndex, toIndex);
  const idsInRange = orderedIds.slice(start, end + 1);
  if (select) return Array.from(new Set([...selectedIds, ...idsInRange]));
  const rangeIdSet = new Set(idsInRange);
  return selectedIds.filter((id) => !rangeIdSet.has(id));
}
